module.exports = __webpack_public_path__ + "static/media/msc.52a0091d.png";